module.exports = __webpack_public_path__ + "img/mastercard.58d23eb.svg";